<template>
	<div class="form-group mod">
		<label :for="id" class="form-label" :class="{'require' : required}">
			{{ title }}
		</label>
		<div class="input-group remove-padding mod">
			<vue-country-code
				@onSelect="onSelect"
				:default-country="getCountry(countryCode)"
				:preferredCountries="['id', 'my', 'bn']">
			</vue-country-code>
			<input type="tel" class="form-control"
			       :id="id"
			       :placeholder="placeholder"
             :autocomplete="autocomplete"
			       v-model="value"
			       @input="$emit('input', value)"
			/>
		</div>

	</div>
</template>

<script>
import {getCountryISO2} from "@/store/utils/countryCode";

export default {
	name: "SOInputTelp",
	props: {
		title: String,
		id: String,
		placeholder: String,
		value: String,
		countryCode: String,
		required: Boolean,
    autocomplete: {
      type: String,
      default: "on", // on || off
    },
	},
	data() {
		return {
			datacountryCode: "",
		}
	},
	mounted() {
		setTimeout(() => {
			this.doFormat()
		}, 50)
	},
	watch: {
		value: {
			handler: function (v) {
				this.doFormat()
			}
		},
	},
	methods: {
		onSelect({name, iso2, dialCode}) {
			this.datacountryCode = dialCode
			this.$emit("country-code", this.datacountryCode)
		},
		doFormat() {
			var checkZero = this.value.substring(0, 1);
			var checkCountryCode = this.value.substring(0, this.datacountryCode.length);
			if (checkZero === "0") {
				this.value = this.value.substring(1);
				return;
			} else if (checkCountryCode === this.datacountryCode) {
				this.value = this.value.substring(this.datacountryCode.length);
				return
			}

			this.value = this.value.replace(/[^0-9]+/g, '');
			this.value = this.value.substring(0, 12)
			this.$emit('input', this.value)
			this.$emit("country-code", this.datacountryCode)
		},
		getCountry(countryCode) {
			return getCountryISO2(countryCode)
		}
	},
}
</script>